export function openWalleeCheckout(data, onError) {
  if (!data || typeof data.uri !== 'string' || !data.uri.trim()) {
    return Promise.reject(new Error('Missing checkout URL'));
  }

  const mode = data.integration_mode || 'payment_page';
  if (mode === 'payment_page') {
    window.location.assign(data.uri);
    return Promise.resolve(mode);
  }
  if (mode !== 'lightbox') {
    return Promise.reject(new Error('Unsupported checkout mode'));
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = data.uri;
    script.onload = () => {
      try {
        if (!window.LightboxCheckoutHandler || typeof window.LightboxCheckoutHandler.startPayment !== 'function') {
          throw new Error('Lightbox initialization failed');
        }
        window.LightboxCheckoutHandler.startPayment(undefined, onError);
        resolve(mode);
      } catch (error) {
        reject(error);
      } finally {
        script.remove();
      }
    };
    script.onerror = () => {
      script.remove();
      reject(new Error('Lightbox script could not be loaded'));
    };
    document.head.appendChild(script);
  });
}